import React, { useEffect, useState, useContext } from "react";
import Breadcrumbs from "./Breadcrumb";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { ProductService } from "../../../services/product-service";
import { useHistory } from "react-router-dom";
import { DataGrid } from "@material-ui/data-grid";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { Modal } from "react-bootstrap";
import AuthContext from "../../../context/auth-context";
import SearchList from "./SearchList";
import Select from "react-select";
import { ReportService } from "../../../services/reports-service";

export const Listcontent = (props) => {
  const ctx = useContext(AuthContext);
  const authPermission = localStorage.getItem("PermissionDetails");

  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "PRODUCTS" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "PRODUCTS" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }
    });
  }, [authPermission]);

  const format2 = "YYYY-MM-DD";

  const [submitloading, setSubmitLoading] = useState(true);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");

  const handleChangeSearchTerm = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const history = useHistory();

  const [products, setProductDetails] = useState([]);
  const [publishers, setPublishers] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [mediums, setMediums] = useState([]);
  const [categories, setCategories] = useState([]);

  const [state, setState] = useState(false);

  const [productID, setproductID] = useState();
  const [publisherId, setPublisherId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [mediumId, setMediumId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [gradeId, setGradeId] = useState("");


  const handleShow4 = (e) => {
    setState({ show4: true });
    setproductID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const fetchStaticData = async () => {
    try {
      const staticDetails = await ReportService.staticDetails();
      setPublishers(staticDetails.publishers);
      setSubjects(staticDetails.subjects);
      setMediums(staticDetails.mediums);
      setCategories(staticDetails.categoriesOrderByOrderId);
    } catch (error) {
    }
  };

  const productSearch = async (searchTerm) => {

    try {
      const result = await ProductService.productDetailsSearch(
        rowsPerPage,
        page,
        searchTerm,
        publisherId,
        subjectId,
        mediumId,
        categoryId,
        gradeId
      );

      setProductDetails(result.results);
      setDataCount(result.pagination.total);
    } catch (err) {
      console.error(err);
    }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await ProductService.productDelete(productID);

      setSubmitLoading(true);
      notify("Product successfully deleted");
      handleClose();
      productSearch();
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  useEffect(() => {
    fetchStaticData();
  },[])

  useEffect(() => {
    productSearch(searchTerm);
  }, [rowsPerPage, page, count, searchTerm, publisherId, subjectId, mediumId, categoryId, gradeId]);

  const handlePublisherChange = (selectedOption, index) => {
    setPublisherId(selectedOption ? selectedOption.value : "");
  };

  let publisherOptions = publishers.map((publisher) => ({
    value: publisher.id,
    label: publisher.name,
  }));

  const handleSubjectChange = (selectedOption, index) => {
    setSubjectId(selectedOption ? selectedOption.value : "");
  };

  let subjectOptions = subjects.map((subject) => ({
    value: subject.id,
    label: subject.name,
  }));

  const handleMediumChange = (selectedOption, index) => {
    setMediumId(selectedOption ? selectedOption.value : "");
  };

  let mediumOptions = mediums.map((medium) => ({
    value: medium.id,
    label: medium.name,
  }));

  const handleCategoryChange = (selectedOption, index) => {
    setCategoryId(selectedOption ? selectedOption.value : "");
  };

  let categoryOptions = categories.map((category) => ({
    value: category.id,
    label: category.name,
  }));

  const handleGradeChange = (event) => {
    const selectedValue = event.target.value;
    setGradeId(selectedValue);
  };

  const calculateHeight = () => {
    // Approximate row height + header + footer
    return rowsPerPage * 52 + 150;
  };

  const clearFilters = () => {
    setPublisherId("");
    setSubjectId("");
    setMediumId("");
    setCategoryId("");
    setGradeId("");
    setSearchTerm("")
    setPage(0);
    setRowsPerPage(10);
  };
  
  const columns = [
    {
      field: "sort_order",
      headerName: "ID",
      flex: 1.3,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "name",
      headerName: "Name",
      flex: 9,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "price",
      headerName: "Price",
      flex: 1.5,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "discount_price",
      headerName: "Discount",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "stock",
      headerName: "Stock Quantity",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "total_sold",
      headerName: "Total Sold",
      flex: 1.2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    // {
    //   field: "created_at",
    //   headerName: "Created Date",
    //   sortable: false,
    //   flex: 2,
    //   disableClickEventBubbling: true,
    //   cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    //   headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    //   renderCell: (params) => {
    //     return <div>{moment(params.row.created_at).format(format2)}</div>;
    //   },
    // },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 2,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        const handleClick = () => {
          window.open(`${window.location.origin}/edit-product/${params.row.id}`, '_blank');

        };
        if (params.row.status === "ACTIVE") {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-success">ACTIVE</span>
            </div>
          );
        } else {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              {" "}
              <span className="badge badge-secondary">DEACTIVE</span>
            </div>
          );
        }
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              history.push(`/edit-product/${params.row.id}`)
            }}
            style={{ cursor: "pointer" }}
            hidden={editHide}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,

      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div hidden={deleteHide}>
            <i
              className="far fa-trash-alt ms-text-danger"
              onClick={() => {
                handleShow4(params.row.id);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumbs />
          <div className="ms-panel">
            <div className="ms-panel-header">
              <h6>Product List</h6>
            </div>

            {/* search for product */}
            

            <div className="row mt-3 mx-3">
                <div className="col-md-4">
                  <label htmlFor="validationCustom15"></label>
                    <SearchList
                      handleChange={handleChangeSearchTerm}
                      searchTerm={searchTerm}
                    />
                </div>
                <div className="col-md-4">
                  <label htmlFor="validationCustom15">Publisher</label>
                    <Select
                      options={publisherOptions}
                      onChange={handlePublisherChange}
                      isClearable
                      placeholder="Filter by Publisher"
                      value={publisherId ? publisherOptions.find(option => option.value === publisherId) : ""}
                      
                    />
                </div>
                <div className="col-md-4">
                  <label htmlFor="validationCustom15">Subject</label>
                  <Select
                      options={subjectOptions}
                      onChange={handleSubjectChange}
                      isClearable
                      placeholder="Filter by Subject"
                      value={subjectId ? subjectOptions.find(option => option.value === subjectId) : ""}
                      
                    />
                </div>
              </div>
              <div className="row mt-3 mx-4">
                <div className="col-md-3">
                  <label htmlFor="validationCustom15">Medium</label>
                    <Select
                      options={mediumOptions}
                      onChange={handleMediumChange}
                      isClearable
                      placeholder="Filter by Medium"
                      value={mediumId ? mediumOptions.find(option => option.value === mediumId) : ""}
                      
                    />
                </div>
                <div className="col-md-3">
                  <label htmlFor="validationCustom15">Category</label>
                    <Select
                      options={categoryOptions}
                      onChange={handleCategoryChange}
                      isClearable
                      placeholder="Filter by Category"
                      value={categoryId ? categoryOptions.find(option => option.value === categoryId): ""}
                    />
                </div>
                <div className="col-md-3">
                  <label htmlFor="validationCustom15">Grade</label>
                    <select
                      name="grade"
                      className="form-control"
                      id="gradeId"
                      onChange={handleGradeChange}
                      value={gradeId}
                    >
                      <option value="">Select Grade</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="12/13">12/13</option>
                    </select>
                </div>
                <div className="col-md-3">
                    <label htmlFor="validationCustom15"></label>
                    <div className="input-group">
                      <button
                          type="button"
                          className="btn btn-primary shadow-none mt-2"
                          onClick={clearFilters}
                        >
                          Clear
                      </button>
                    </div>
                  </div>
              </div>
            <div>
              <Modal
                show={state.show4}
                onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header>
                  <h3 className="modal-title has-icon ms-icon-round ">
                    Confirm Deletion
                  </h3>
                  <button type="button" className="close" onClick={handleClose}>
                    <span aria-hidden="true">×</span>
                  </button>
                </Modal.Header>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "2vh",
                  }}
                >
                  <h6 style={{ color: "red" }}>
                    Are you sure you want to remove this item ?
                  </h6>
                </div>
                <Modal.Footer>
                  <div className="col-md-2" hidden={submitloading}>
                    <div className="spinner spinner-7">
                      <div className="bounce1" />
                      <div className="bounce2" />
                      <div className="bounce3" />
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary shadow-none"
                    style={{ backgroundColor: "red" }}
                    onClick={onDelete}
                  >
                    Delete
                  </button>

                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                </Modal.Footer>
              </Modal>
            </div>

            <div className="ms-panel-body">
              <div style={{ minHeight: calculateHeight(), height: calculateHeight(), flex: "100%" }}>
                <DataGrid
                  rows={products}
                  disableExtendRowFullWidth={false}
                  columns={columns}
                  pageSize={rowsPerPage}
                  pagination
                  hideFooter
                  autoHeight
                />
                <TablePagination
                  component="div"
                  count={count}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Listcontent;
